import { useEffect } from 'react';
import * as THREE from 'three';

/**
 * useFogHook
 * Adds or updates fog in the Three.js scene.
 * Supports THREE.Fog and THREE.FogExp2.
 *
 * @param {Object} params
 * @param {THREE.Scene} params.scene - The Three.js scene object
 * @param {string} params.fogType - 'Fog' or 'FogExp2'
 * @param {string|number} params.color - Fog color
 * @param {number} [params.near] - Near distance (for Fog)
 * @param {number} [params.far] - Far distance (for Fog)
 * @param {number} [params.density] - Density (for FogExp2)
 */
const useFogHook = ({
  scene,
  fogType = 'Fog',
  color = 0x0000ff,
  near = 1,
  far = 10,
  density = 2,
}) => {
  useEffect(() => {
    if (!scene) return;

    // Remove any previous fog
    scene.fog = null;

    // Add new fog based on type
    if (fogType === 'Fog') {
      scene.fog = new THREE.Fog(color, near, far);
    } else if (fogType === 'FogExp2') {
      scene.fog = new THREE.FogExp2(color, density);
    }

    // Cleanup fog on unmount
    return () => {
      //  if (scene) scene.fog = null;
    };
  }, [scene, fogType, color, near, far, density]);
};

export default useFogHook;
